<template>
  <div>
    <s-header>
      <!-- <template> -->
      <div class="mt-3 -mb-3">Inventory</div>
      <!-- </template> -->
      <!-- <template
        v-slot:sub-heading
        v-if="isTodayInventoryDay && isCurrentInventoryOpen"
      >
        <div class="-mt-8 text-red-700">Today</div>
      </template>
      <template
        v-slot:sub-heading
        v-if="isTodayInventoryDay && !isCurrentInventoryOpen"
      >
        <span class="-mt-8 text-red-700">Completed!</span>
      </template> -->
    </s-header>

    <section
      v-if="!isTodayInventoryDay && !isCurrentInventoryOpen"
      class="mt-10 px-6 py-2 text-p1 text-2xl font-semibold text-gray-800 text-left max-w-lg leading-tight border-l-4 border-gray-800"
    >
      Inventories happen automatically on Monday, and take the place of ordering
      for that day.
    </section>

    <section
      v-if="isTodayInventoryDay && !isCurrentInventoryOpen"
      class="mt-10 px-6 py-2 text-p1 text-2xl font-semibold text-gray-800 text-left max-w-lg leading-tight border-l-4 border-gray-800"
    >
      Today is inventory day, but the inventory has already been completed!
    </section>

    <section v-if="isCurrentInventoryOpen">
      <order-item
        v-for="(id, index) in inventoryItems"
        :key="id"
        :index="index"
        :active-item="activeChild"
        :id="id"
        :value="
          currentInventory[id]
            ? Object.prototype.hasOwnProperty.call(
                currentInventory[id],
                'amount'
              )
              ? currentInventory[id].amount
              : currentInventory[id]
            : null
        "
        :title="products[id].name"
        :subtitle="
          products[id].inputType === 'number'
            ? products[id].question
            : products[id].inventoryQuestion || null
        "
        input-type="number"
        @showProductCountingInfo="
          $modal.show('modal--product-counting-info', $event)
        "
        @clicked="activeChild = $event"
        @putValue="updateCurrentInventoryItem"
        class="mt-2"
      />
    </section>

    <div class="mt-6 flex flex-row justify-start">
      <s-button
        v-if="isCurrentInventoryOpen"
        left-icon="message"
        :class="
          isCurrentInventoryCompleted
            ? 'shadow-lg'
            : 'opacity-50 cursor-not-allowed'
        "
        @focus="activeChild = null"
        @click="isCurrentInventoryCompleted || isManager ? submit() : ''"
      >
        Submit
      </s-button>
      <!-- <s-button
        v-if="
          !isCurrentInventoryOpen && isTodayInventoryDay && isAdmin && false
        "
        @click="isAdmin ? create() : ''"
        class="shadow-lg"
      >
        Create New
      </s-button> -->
      <s-button
        v-if="isAdmin && isCurrentInventoryOpen"
        :class="isCurrentInventoryOpen ? 'ml-4' : ''"
        left-icon="trash-alt"
        class="shadow-lg"
        @focus.stop="activeChild = null"
        @click="deleteCurrentInventory"
      >
        Delete Inventory
      </s-button>
    </div>
    <div v-if="currentInventory && currentInventory.completed" class="mt-6 flex flex-row justify-start">
      <s-button left-icon="dashboard" @click="$router.push('/dashboard')">
        Go to Dashboard
      </s-button>
    </div>

    <modal-product-counting-info />
    <!-- <modal-confirm /> -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import OrderItem from '@/components/OrderItem'
import SButton from '@/components/Button'
import SHeader from '@/components/SHeader'
import ModalProductCountingInfo from '@/components/ModalProductCountingInfo'
// import ModalConfirm from '@/components/ModalConfirm'

export default {
  name: 'InventoryList',
  data() {
    return {
      activeChild: null
    }
  },
  components: {
    OrderItem,
    SHeader,
    SButton,
    ModalProductCountingInfo
    // ModalConfirm
  },
  computed: {
    ...mapGetters(['isTodayInventoryDay']),
    ...mapGetters('user', ['isManager', 'isAdmin']),
    ...mapGetters('storeModule', [
      'inventoryItems',
      'currentInventory',
      'currentInventoryId',
      'isCurrentInventoryOpen',
      'isCurrentInventoryCompleted'
    ]),
    ...mapGetters('storeModule/products', ['products'])
    // ...mapGetters('storeModule/invoices', ['daysSinceLastInvoiceCreated'])
  },
  methods: {
    ...mapActions('storeModule', [
      // 'createNewInventory',
      'updateCurrentInventoryItem',
      'deleteCurrentInventory'
    ]),
    // create: function() {
    //   this.activeChild = null
    //   this.createNewInventory()
    // },
    submit: function () {
      if (this.isCurrentInventoryCompleted) {
        // if (this.daysSinceLastInvoiceCreated > 1) {
        //   this.$modal.show('modal--submit-inventory', {
        //     title: 'Previous Days Orders',
        //     message:
        //       'There are previous days without orders. Do you want to create orders for those vendors as well as todays vendors?'
        //   })
        // }
        this.activeChild = null
        this.$modal.show('modal--submit-order', {
          isInventory: true,
          id: this.currentInventoryId
        })
      }
    }
  }
}
</script>
